import { customerThemeWithDatepicker as hiveTheme, } from '@mehilainen/hive/theme-datepicker';
import { createTheme } from '@mui/material';
import _ from 'lodash';
export const theme = createTheme(Object.assign(Object.assign({}, hiveTheme), { components: Object.assign({}, hiveTheme.components) }));
export const getPartialTheme = (...keys) => createTheme(Object.assign(Object.assign({}, theme), { components: Object.assign({}, _.pick(theme.components, keys)) }));
